<template>
  <section class="d2-report-toolbar">
    <MultiSelect
      v-model="viewTypeSelect"
      :options="viewTypeOptions"
      optionLabel="text"
      :placeholder="lang['components']['Report']['Condition']['viewTypeSelect_placeholder']"
      display="chip"
      @change="handleChangeSelect"
      class="w-auto lg:w-1/2 md:w-1/2 w-1/3 h-10 ml-2s rounded-md text-xs"
    />
    <div
      v-show="calendarShow"
      class="d2-report-calendar-popup"
      @click.stop="calendarShow=true"
    >
      <div>
        <Calendar
          v-model="selectConditionDateRange"
          selectionMode="range"
          :manualInput="false"
          :numberOfMonths="2"
          :minDate="minDateValue"
          :maxDate="maxDateValue"
          inline
        />
      </div>
      <div class="rounded-md" style="border-width: 1px;">
        <ul>
          <li
            v-for="(dateList, index) in settiingDateList"
            :key="index"
            :class="{ 'font-bold pl-4': index == 0, 'text-sm cursor-pointer pl-8 hover:bg-blue-200': index != 0 }"
            :style="index == 0 ? { 'line-height': `60px` } : { 'line-height': `32px` }"
            @click="getDateList(dateList.date_start, dateList.date_end)"
          >
            {{dateList.name}}
          </li>
        </ul>
      </div>
    </div>
    <div class="flex flex-row flex-wrap items-center gap-1">
      <InputText
        v-model="labelDate"
        class="d2-condition-dropdown h-8 ml-2s mr-2 rounded-md"
        readonly
        @click.stop="calendarShow=true"
      />
      <button
        class="d2-report-btn-search"
        @click="search()"
      >
        <i class="fas fa-search"></i> {{lang['components']['Report']['Condition']['search_button_text']}}
      </button>
      <button
        class="d2-report-btn-download"
        @click="download()"
      >

        <i class="pi pi-download"></i> {{lang['components']['Report']['Condition']['download_button_text']}}
      </button>

      <SplitButton
       label="下載"
       icon="pi pi-download"
       :model="items"
       v-if="false"
      ></SplitButton>

      <button
        class="d2-report-btn-icon"
        v-tooltip.bottom="'重新整理'"
        v-if="false"
      >
        <i class="pi pi-undo"></i>
      </button>
      <button
        class="d2-report-btn-icon"
        @click="toggle"
        aria:haspopup="true"
        aria-controls="overlay_panel"
        v-tooltip.bottom="`${lang['components']['Report']['Condition']['historical_record_button_text']}`"
      >
        <i class="pi pi-clock"></i>
      </button>
    </div>
    <!-- Overlay Panel -->
    <OverlayPanel
      ref="reportRecordsPanel"
      appendTo="body"
      id="overlay_panel"
      :breakpoints="{'960px': '75vw'}"
      class="rounded-xl w-8/12 d2-condition-overlay"
    >
      <h1 class="overpanel-title">
        {{lang['components']['Report']['Condition']['overpanel_title']}}
      </h1>
      <div class="close-btn" @click="toggle">
        <span class="p-overlaypanel-close-icon pi pi-times"></span>
      </div>
      <DataTable
        :value="records"
        :paginator="true"
        class="p-datatable-customers overflow-y-auto condition-datatable"
        :rows="10"
        dataKey="id"
        :rowHover="true"
        v-model:filters="filters"
        filterDisplay="menu"
        :loading="loading"
        paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
        :rowsPerPageOptions="[10,25,50]"
        :currentPageReportTemplate="`${lang['components']['Report']['Condition']['datatable_page_info']}`"
        :globalFilterFields="['actions','event','item','updatedTime']"
        responsiveLayout="scroll"
        @page="onPageCange($event)"
      >
        <!-- Header -->
        <template #header class="bg-white">
          <div class="p-d-flex p-jc-between p-ai-center w-full bg-white">
            <span class="p-input-icon-left w-full">
              <i class="pi pi-search" />
              <InputText v-model="filters['global'].value" placeholder="Keyword Search" class="w-full rounded-md" />
            </span>
          </div>
        </template>

        <template #empty>
          No records found.
        </template>

        <template #loading>
          Loading records data. Please wait.
        </template>

        <Column field="actions" :header="`${lang['components']['Report']['Condition']['field_a']}`" sortable style="min-width: 14rem">
          <template #body="{data}">
            {{ data.actions }}
          </template>
          <!--<template #filter="{filterModel}">
            <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by name" />
          </template>-->
        </Column>

        <Column field="event" :header="`${lang['components']['Report']['Condition']['field_b']}`" sortable style="min-width: 14rem">
          <template #body="{data}">
            <p v-html="data.event"></p>
          </template>
          <!--<template #filter="{filterModel}">
            <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by name" />
          </template>-->
        </Column>

        <!--<Column selectionMode="multiple" headerStyle="width: 3rem"></Column>-->
        <Column field="item" :header="`${lang['components']['Report']['Condition']['field_c']}`" sortable style="min-width: 10rem">
          <template #body="{data}">
            <p v-html="data.item"></p>
          </template>
          <!--<template #filter="{filterModel}">
            <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by name" />
          </template>-->
        </Column>

        <Column field="updatedTime" :header="`${lang['components']['Report']['Condition']['field_d']}`" sortable style="min-width: 14rem">
          <template #body="{data}">
            {{ data.updatedTime }}
          </template>
          <!--<template #filter="{filterModel}">
            <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by name" />
          </template>-->
        </Column>

      </DataTable>
    </OverlayPanel>
  </section>
</template>

<script>

import MultiSelect from 'primevue/multiselect';
// import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import SplitButton from 'primevue/splitbutton'
// import Dialog from 'primevue/dialog'
import OverlayPanel from 'primevue/overlaypanel'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
// import ColumnGroup from 'primevue/columngroup'
import { format } from 'date-fns'
import { FilterMatchMode, FilterOperator } from "primevue/api"
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'Condition',
  components: {
    MultiSelect,
    Calendar,
    SplitButton,
    OverlayPanel,
    DataTable,
    Column,
    InputText
  },
  props: {
    dbCampaignId: {
      type: Number
    },
    viewDatalist: {
      type: Object,
      default: () => []
    },
    logDatalist: {
      type: Object,
      default: () => []
    },
    campaignIdData: {
      type: String
    },
    dateIntervalData: {
      type: Object,
    },
    defaultDateIntervalData: {
      type: Object,
    },
    defaultMinDateData: {
      type: String
    },
    defaultMaxDateData: {
      type: String
    },
    defaultSettiingDateListData: {
      type: Object
    },
    lang: {
      type: Object
    },
    calendarMainShow: {
      type:Boolean
    },
  },
  data() {
    return {
      minDateValue: null,
      viewTypeSelect: [],
      viewTypeOptions: [],
      selectConditionDateRange: [new Date('2019-06-10'), new Date('2019-11-05')],
      campaignId: null,
      records: [],
      items: [
          {
              label: '日期區間',
              icon: '',
              command: () => {
                  // console.log('download #1:'+this.selectConditionDateRange);
                  // this.$toast.add({severity:'success', summary:'Updated', detail:'Data Updated', life: 3000});
              }
          },
          {
              label: '全範圍',
              icon: '',
              command: () => {
                // console.log('download #2:'+this.selectConditionDateRange);
                  // this.$toast.add({ severity: 'warn', summary: 'Delete', detail: 'Data Deleted', life: 3000});
              }
          }
      ],
      loading: false,
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        },
        actions: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        event: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        item: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        updatedTime: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        }
      },
      calendarStatus: false,
      calendarShow: false,
      labelDate: '',
      settiingDateList:[
        { name: '預設日期', date_start: '', date_end: ''},
        { name: '現有資料全範圍', date_start: '', date_end: ''},
        { name: '結束投遞的前一天', date_start: '', date_end: ''},
        { name: '結束投遞的前7天', date_start: '', date_end: ''},
        { name: '結束投遞的前14天', date_start: '', date_end: ''},
        { name: '結束投遞的前30天', date_start: '', date_end: ''},
        { name: '結束投遞的當週', date_start: '', date_end: ''},
        { name: '結束投遞的上週', date_start: '', date_end: ''},
        { name: '結束投遞的當月', date_start: '', date_end: ''},
        { name: '結束投遞的上個月', date_start: '', date_end: ''},
      ],
    };
  },
  watch: {
    viewDatalist(v) {
      // console.log('viewDatalist');
      // console.log(v);

      // console.log('b viewTypeSelect');
      // console.log(this.viewTypeSelect);
      // console.log('b viewTypeOptions');
      // console.log(this.viewTypeOptions);

      this.viewTypeSelect = v
      this.viewTypeOptions = v

      // console.log('a viewTypeSelect');
      // console.log(this.viewTypeSelect);
      // console.log('a viewTypeOptions');
      // console.log(this.viewTypeOptions);
    },
    logDatalist(v){
      this.records = v
    },
    campaignIdData(v){
      this.campaignId = v
    },
    defaultDateIntervalData(v){
      this.selectConditionDateRange = v
    },
    defaultMinDateData(v){
      this.minDateValue = v
    },
    defaultMaxDateData(v){
      this.maxDateValue = v
    },
    defaultSettiingDateListData(v){
      this.settiingDateList = v
    },
    selectConditionDateRange(value){
      // console.log('value');
      // console.log(value);

      this.selectConditionDateRange = value

      let startDate = '';
      if(value[0] != '' && value[0] != null && typeof value[0] != 'undefined'){
        startDate = format(value[0], 'yyyy-MM-dd');
      }
      let entDate = '';
      if(value[1] != '' && value[1] != null && typeof value[1] != 'undefined'){
        entDate = format(value[1], 'yyyy-MM-dd');
      }

      this.labelDate = startDate + ' ~ ' + entDate;

      // this.$emit('update:dateIntervalData', value)
    },
    calendarMainShow(value){
      let _tmpCalendarShow = value.split('_');

      if(_tmpCalendarShow[0] != null && _tmpCalendarShow[0] != '' && typeof _tmpCalendarShow[0] != 'undefined'){
        this.calendarShow = false;
      }
    }
  },
  methods: {
    handleChangeSelect() {
      this.$emit('selectCharts', [...this.viewTypeSelect]);
    },
    search() {
      const searchData = {
        type: this.viewTypeSelect,
        dateRange: [...this.selectConditionDateRange]
      }

      this.$emit('search', searchData)
      this.$emit('update:dateIntervalData', this.selectConditionDateRange)
    },
    toggle(event) {
      this.$refs.reportRecordsPanel.toggle(event)

      this.records = [];
      this.loading = true;
      axios
        .post('https://www.autoturn.net/api/report/report_log_list.php', Qs.stringify({
          s_code: this.$route.params.id,
          campaign_id: this.dbCampaignId
        }))
        .then((reResponse) => {
          // console.log(reResponse.data);

          // this.logData = reResponse.data.return_data
          this.loading = false;
          this.records = reResponse.data.return_data;
          // console.log(this.keywordList);
        });
    },
    download(){
      var nowDate = this.selectConditionDateRange;
      var id = this.campaignId;

      let return_date = [];

      var date = new Date();
      const formatDate = (date)=>{
        let formatted_date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
        return formatted_date;
      }

      for (let i = 0; i < nowDate.length; i++) {
        if(nowDate[i] != '' && nowDate[i] != null){
          return_date.push(formatDate(nowDate[i]));
        }
      }

      window.open("https://www.autoturn.net/api/report/report_download.php?sr_i="+id+"&date="+JSON.stringify(return_date), '_blank');
    },
    onPageCange(event){
      // console.log(event);
    },
    getDateList(startDate, endDate){
      this.selectConditionDateRange = [new Date(startDate), new Date(endDate)];
    }
  },
  // computed: {
  //   viewDatalistData: {
  //     get: function () {
  //       return this.viewDatalist
  //     },
  //     set: function (value) {
  //       this.$emit('update:viewDatalistData', value)
  //     },
  //   }
  // }
};
</script>

<style lang="scss" scoped>

.overpanel-title {
  padding: 1rem 1rem;
  font-family: PingFang HK;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #252525;
}

.close-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #F6F6F6;
  color: #000000;
  width: 2rem;
  height: 2rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
  position: absolute;
  top: 1.75rem;
  right: 1rem;
  cursor: pointer;
}

.condition-datatable {
  height: 600px;
}

@media (max-width: 1023px) {
  .condition-datatable {
    height: auto;
    max-height: 55vh;
  }
}

</style>
